import request from '../network';

export interface PetTypeDictItem {
  dictCode: number | string;
  dictName: string;
}

export const getPetTypeListApi = () => {
  return request<{ code: number; msg?: string; data?: PetTypeDictItem[] }>({
    url: '/member/royalcanin/admin/petType/list',
    method: 'GET',
  });
};

export interface PetLifeStageItem {
  id: number;
  petType: string;
  stageName: string;
  minMonths?: number;
  maxMonths?: number;
  [key: string]: any;
}

export const getLifeStageByPetTypeApi = (petType: number | string) => {
  return request<{ code: number; msg?: string; data?: PetLifeStageItem[] }>({
    url: '/member/royalcanin/admin/petLifeStage/getListByPetType',
    method: 'GET',
    params: { petType },
  });
};
